<template>
    <div class="edit-pannel"
        v-if="value"
        >
        <div class="fixed">
<!--            <h1>{{title}}<span @click="closePannel" class="pannelclose"><i class="material-icons-outlined align-middle">close</i></span></h1>-->
            <slot></slot>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['value','title'],
    methods: {
      closePannel: function () {
        this.$emit('input', !this.value)
      },
    }
  }
</script>
